import { cn } from '~/lib/utils'
import { type ClassValue } from 'clsx'

export const Field = ({
    children,
    className,
}: {
    children: React.ReactNode
    className?: ClassValue
}) => {
    return (
        <div className={cn('flex flex-col gap-2', className)}>{children}</div>
    )
}

export const FieldError = ({ children }: { children: React.ReactNode }) => {
    return <div className='text-sm text-red-500 font-semibold'>{children}</div>
}
